module.exports = __webpack_public_path__ + "static/media/EarthDayRecipeBook2017.fd03ab64.pdf";